import React, { useEffect, useMemo, useRef, useState } from 'react';
import compassImg from './laban-400px.png';
// import compassImg from './laban-400pxbu.webp';
import compassArrowImg from './arrow-laban.png';
import RotationHandler from './RotationHandler';

import { COMPASS_DEGREE_SCENE_DATA } from 'consts/hardcoded-data';

import './style.scss';

const radiansToDegrees = (radians) => {
  return Math.round(radians * (180 / Math.PI));
};

const Compass = ({ deg }) => {
  const compassRef = useRef(null);
  useEffect(() => {
    compassRef.current.style.transform = `rotate(${-deg || 0}deg)`;
  }, [deg, compassRef]);

  return (
    <div className="compass-container">
      <div ref={compassRef} className="compass-icon">
        <img src={compassImg} alt="compass" />
      </div>
      <div className="compass-arrow">
        <img src={compassArrowImg} alt="compass-arrow" />
      </div>
    </div>
  );
};

const CompassContainer = ({
  currentPano,
  cameraParams,
  sceneRotation,
  ...props
}) => {
  const [rotationY, setRotationY] = useState(0);
  const isVisible = useMemo(() => {
    if (!currentPano?._id) return false;
    return Object.prototype.hasOwnProperty.call(
      COMPASS_DEGREE_SCENE_DATA,
      currentPano._id
    );
  }, [currentPano]);

  const defaultDegree = useMemo(() => {
    if (!currentPano?._id) return 0;
    const value = COMPASS_DEGREE_SCENE_DATA[currentPano._id];
    return typeof value === 'number' ? value : 0;
  }, [currentPano]);

  const compassDeg =
    useMemo(() => radiansToDegrees(rotationY), [rotationY]) || 0;

  if (!isVisible) return null;

  return (
    <>
      {currentPano && (
        <RotationHandler
          cameraParams={cameraParams}
          sceneRotation={sceneRotation}
          setRotationY={setRotationY}
          currentPano={currentPano}
        />
      )}
      <Compass {...props} deg={compassDeg + defaultDegree} />
    </>
  );
};

export default CompassContainer;
